export const header = [
    {name: 'Rule Name', key: 'ruleName'}, 
    {name: 'Modified', key: 'modified_at'}, 
    {name: 'Tags', key: 'tags'}, 
    {name: 'Status', key: 'status'}, 
    {name: 'Actions', key: 'Actions'}
]